// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Variables */\n[data-v-2500ffa0]:export {\n  menuBg: #b58643;\n  menuText: #e0e0e0;\n  menuActiveText: #ffe164;\n  menuActiveBg: #906a35;\n}\n\n/* Mixins */\n.small[data-v-2500ffa0] {\n  font-size: 9px;\n}\n.el-button--mini[data-v-2500ffa0] {\n  padding: 0;\n  border: 0;\n  background: transparent !important;\n  box-shadow: none;\n}\n.el-button[data-v-2500ffa0] {\n  background: transparent !important;\n  border: none;\n  padding: 0;\n}", ""]);
// Exports
module.exports = exports;
